<template>
  <div class="product-list-header" :class="{'logo':from}">
    <div class="slot leftimg" v-if='from=="home" && config' ></div>
    <div class="slot iconfont" @click="$router.go(-1)" v-else >&#xe64f;</div>
    <div class="common-search" @click="onSearch">
    	<select class="optionsearch" id="optionsearch" v-model="optionsearch">
    		<option value="1">Product</option>
    		<option value="2">Seller</option>
    	</select>
      <input type="text" placeholder="Keyword or name" readonly="true" autocomplete="off" v-model="keyword">
    </div>
      <div style="display: none;" class="right iconfont popup-menu-area" @click="popupMore">&#xe680;<div v-if="showDot" class="dot"></div></div>
      <header-more v-show="popupVisible" :showDot="showDot"></header-more>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getChatCount } from '../../../api/memberInstantMessage'
import HeaderMore from '../..//HeaderMore'
export default {
  name: 'HomeCommonSearch',
  components: {
    HeaderMore
  },
  props: ['value', 'from','datas'],
  watch: {
    value: function (value) {
      if (value) {
        this.keyword = value
      }
    },
    datas: function (value) {
      if (value) {
        this.optionsearch = value
      }
    },
  },
  mounted: function () {
    document.addEventListener('click', (e) => {
      let thisClassName = e.target.className
      if (thisClassName != 'right iconfont popup-menu-area') {
        this.popupVisible = false
      }
    })
    document.addEventListener('touchmove', (e) => {
      this.popupVisible = false
    })
  },
  data () {
    return {
      keyword: this.value ? this.value : '', // 关键字
      popupVisible: false,
      showDot: false,
      optionsearch:this.datas ? this.datas : '1',
      
    }
  },
  created: function () {
    if (this.isOnline) {
      getChatCount().then(res => {
        if (res.result) {
          if (!this.showDot) {
            this.showDot = {}
          }
          this.showDot['chat'] = true
        }
      })
    }
  },
  computed: {
    ...mapState({
      config: state => state.config.config,
      isOnline: state => state.member.isOnline
    })
  },
  methods: {
    onSearch () {
      this.$router.push({ name: 'HomeSearch', params: { isFromHome: true } })
    },
    popupMore () {
      if (!this.popupVisible) {
        this.popupVisible = true
      } else {
        this.popupVisible = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.dot{position:absolute;width:.5rem;height:.5rem;background:red;border-radius:50%;top:.2rem;right:0;}
  .product-list-header.logo{
  .slot{width:2.5rem;text-align:center;line-height:1.6rem;
    img{max-height:100%;max-width:100%;}
  }
  .common-search{padding: 0rem;}
  }
  .product-list-header {
    display: flex;
    height: 2rem;
    padding: 0rem;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  .slot{width:1.6rem;font-size:.8rem;text-align: center;}
  }
  .common-search{
    flex:1;
    padding: 0.35rem 0.3rem 0.35rem 0;
    position: relative;
  }
  
  .optionsearch{position: absolute;left: 0.2rem;top: 0.4rem;height: 1.55rem;line-height: 1.6rem;cursor: pointer;
  width: 4rem;background: #fff;font-size: 0.7rem;border: none;border-radius: 0.6rem;}
  .common-search input {
    box-sizing: border-box;
    width: 100%;
    height: 1.6rem;
    border-radius: 1.6rem;
    padding-right: 0.6rem;
    background: #FFF url(../../../assets/image/home/icon_search.png) no-repeat 0.4rem center;
    background-size:0.8rem;
    font-size:0.7rem;
    color: #bbc2c8;
    padding-left:4.3rem;
    border: 0;
  }
  .right{width:1.6rem;height: 1.6rem;text-align:center;line-height: 1.6rem;position:relative}
  .common-search input::-webkit-input-placeholder{ color: #bbc2c8;letter-spacing: 1px;}
  .leftimg{display:none;}
</style>
